function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}, React.createElement("path", {
  d: "M18.5 7.354s-1.351.146-1.95.266c-.48-.513-1.164-.832-1.921-.832-1.454 0-2.633 1.179-2.633 2.632 0 .205.023.408.068.599-2.187-.108-4.126-1.157-5.424-2.75-.227.39-.357.841-.357 1.324 0 .914.465 1.718 1.171 2.19-.431-.014-.837-.132-1.192-.33v.035c0 1.274.907 2.338 2.111 2.579-.386.106-.792.121-1.188.046.335 1.045 1.307 1.806 2.458 1.829-1.125.882-2.522 1.25-3.896 1.089 1.165.747 2.549 1.184 4.035 1.184 4.841 0 7.488-4.012 7.488-7.489l-.008-.34c.514-.373.885-1.504 1.238-2.032z"
}), React.createElement("circle", {
  strokeLinecap: "round",
  cx: 12,
  cy: 12,
  r: 11.5
}));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Twitter.273cdb32.svg";
export { ForwardRef as ReactComponent };